<template>
  <div class="section__container">
    <div class="container">
      <div class="row">
        <div class="col green-column">
          <p class="top-title">Última transacción</p>
          <p class="middle-title">${{ returnFormatNumber(orderBook.LastTrade) }}</p>
          <p class="bottom-title">{{ orderBook.LastTradeText }}</p>
        </div>
        <div class="col green-column">
          <p class="top-title">Valor estimado</p>
          <p class="middle-title">${{ returnFormatNumber(orderBook.EstimatedValue) }}</p>
          <p class="bottom-title">{{ orderBook.EstimatedValueText }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col blue-column">
          <p class="top-title">Volumen de transacciones</p>
          <p class="middle-title">${{ returnFormatNumber(orderBook.TradeVolume) }}</p>
          <p class="bottom-title">{{ orderBook.TradeVolumeText }}</p>
        </div>
        <div class="col blue-column">
          <p class="top-title">Market cap</p>
          <p class="middle-title">${{ returnFormatNumber(orderBook.MarketCap) }}</p>
          <p class="bottom-title">{{ orderBook.MarketCapText }}s</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col title_filled">
          Órdenes recientes
        </div>
        <div class="col subtitle_filled">
          Solo se muestran las 10 ordenes más recientes
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <p class="top-title subtitle_filled">Completadas</p>
        </div>
        <div class="col table__filled_columns_background">
          <p class="top-title subtitle_filled text-center">Tamaño</p>
        </div>
        <div class="col">
          <p class="top-title subtitle_filled text-right">Precio de la Transacción</p>
        </div>
      </div>
      <div v-for="(item, index) in fillOrders" :key="index"  class="row table__filled_columns_border">
        <div class="col">
          <p class="top-title filled_content">{{ returnDate(item.attributes.Filled) }}</p>
        </div>
        <div class="col table__filled_columns_background">
          <p class="filled_content_size">{{ item.attributes.Size }} Token</p>
        </div>
        <div class="col">
          <p class="filled_content text-right">{{ item.attributes.TransactedPrice }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import numeral from 'numeral'

export default {
  name: 'FinancialsTab',
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      orderBook:{},
      fillOrders: []
    }
  },
  created () {
    this.orderBook = this.property.attributes.property_order_book.data.attributes
    if(this.property.attributes.recently_filled_orders.data) {
      this.fillOrders = this.property.attributes.recently_filled_orders.data
    }
    
    console.log('ESto paso en la property Details', this.property)
  },
  methods: {
    returnDate (value) {
      return moment(value).format('LL')
    },
    returnFormatNumber(value) {
      return numeral(value).format("0,0.0")
    }
  }
}
</script>
<style lang="scss">
.table__filled_columns_border {
  border-bottom:1px solid #D4CAE3; 
  border-left:1px solid #D4CAE3; 
  padding-top: 10px;
  margin-bottom: 5px;
}

.table__filled_columns_background {
  background: linear-gradient(180deg, rgba(154, 238, 197, 0.3) 0%, rgba(154, 238, 197, 0) 100%);
}

.filled_content {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #0D051A;
}

.filled_content_size {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: center;
  color: #0D051A;
}

.subtitle_filled {
  //styleName: MR18;
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #828282;
}
.title_filled {
  //styleName: Montserrat Semibold/H3MSB24;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  color: #351467;
;

}

.bottom-title {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color:#464448
}
.middle-title {
  //styleName: Primary/H3MSB38;
  font-family: Montserrat;
  font-size: 38px;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: 0em;
  text-align: left;
  color: #351467;
}
.top-title {
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
  color: #351467;
}
.green-column {
  width: 360px;
  height: 134px;
  padding: 16px;
  border-radius: 8px;
  gap: 48px;
  background: #CAEEDD;
  margin: 7px;
}

.blue-column {
  width: 360px;
  height: 134px;
  padding: 16px;
  border-radius: 8px;
  gap: 48px;
  background: #E8F2FD;
  margin: 7px;
}

.section__container {
  display: flex;
  flex-direction: column;
  gap: 44px;
}

.title {
  font-size: 24px;
  line-height: 30px;
  font-weight: 600;
  font-family: 'Montserrat', sans-serif;
  color: #351467;
  margin-bottom: 24px;
}

.table__container {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.title__background {
  margin: 16px 0;
  padding: 14px 16px;
  background-color: #CAEEDD;
  font-weight: 600;
  color: #351467;
}
</style>